import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { FileData } from 'src/app/models';
import { FilesService } from 'src/app/services';

@Component({
  selector: 'app-view-file-data',
  templateUrl: './view-file-data.component.html',
  styleUrls: ['./view-file-data.component.css']
})
export class ViewFileDataComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  loading: boolean;
  fileData: FileData;
  fileId: string;
  attrName: string[] = [];
  tableData: object[] = [];
  fileLink: string;

  @Input() set data(value) {

    if (value != null) {

      this.fileId = value.file_id;
    }
  }

  constructor(
    public ngProgress: NgProgress,
    private apiFileService: FilesService,
    private router: Router,
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.getFileInfo();
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }


  /**
   * 
   * @param file
   */
  getFileInfo(): void {

    this.fileData = null;
    this.loading = true;

    this.progressRef.start();

    this.subscriptions.add(
      this.apiFileService.getFileInfo(this.fileId).subscribe(response => {
        console.log("[RESPONSE] getFileInfo: ", response);

        if (response != null) {

          this.fileData = response.result;

          this.getImageContent(response.result.file_id);

          if (this.fileData.link) {

            // this.fileData.link = this.fileData.link.substring(26);
          }
        }

        this.loading = false;
        this.progressRef.complete();
      })
    );
  }

  /**
   * 
   * @param size number
   * @returns string
   */
  convertationToMb(size: number): string {

    let convertData: number;
    let dataType: string = "kb";

    convertData = size / 1024;

    if (convertData > 1024) {
      convertData = convertData / 1024;
      dataType = "mb"
    }

    return convertData.toFixed(2) + " " + dataType;
  }

  productEdit(product_id: string) {

    this.router.navigate(['products', 'edit', product_id]);

    this.activeModal.close();

  }

  /**
   * 
   * @param id 
   */
  onEdit(id: string) {

    this.router.navigate(['files', 'edit', id]);

  }


  /**
   * DOWNLOAD FILE
   * @param file
   */
  downloadFile(fileId: string, fileName: string): void {

    this.apiFileService.downloadFile(fileName, fileId);
  }

  /**
   * 
   * @param index 
   * @param image 
   */
  getImageContent(file_id: any): void {

    this.fileLink = null;

    this.subscriptions.add(

      this.apiFileService.getImageContent(file_id).subscribe((response: any) => {

        if (response != null) {

          this.fileLink = response.result;
        }
      })
    );
  }
}
